<script setup lang="ts">
defineProps<{
  title: string
}>()
</script>

<template>
  <a
    class="
      block w-min whitespace-nowrap rounded-xl bg-main-gray-low px-[24px] py-3 text-center text-sm font-medium
      leading-[1.43] text-main-green !no-underline md:py-[14px] md:leading-[1.71]
    "
    href="#"
  >
    {{ title }}
  </a>
</template>
